import * as React from 'react';
import './CheckboxAllowDeny.css';

const CheckboxAllowDeny = (props: any) => {
  return (
    <span className="checkbox-allow-deny">
      <input
        {...props}
        type="checkbox"
      />
      <span
        className="allow-deny"
      />
    </span>
  )
}

export default CheckboxAllowDeny




// WEBPACK FOOTER //
// ./src/modules/shared/components/checkbox-allow-deny/CheckboxAllowDeny.tsx